import Pattern from '../ASSETS/MindShapesPatternRed.png';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
